import React from 'react';

const IconAcrossArrow = () => (
    <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <title>Icon / Across Arrow</title>
        <g id="Icon-/-Across-Arrow" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <polygon
                id="Path"
                fill="#000000"
                fillRule="nonzero"
                transform="translate(12, 12) rotate(90) translate(-12, -12)"
                points="11 20 11 7.825 7.4 11.425 6 10 12 4 18 10 16.6 11.425 13 7.825 13 20"
            ></polygon>
        </g>
    </svg>
);

const IconAddAnnotation = (fill) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 -2 24 24">
        <g id="Add-Annotation" transform="translate(-4454 750)">
            <path id="Frame" d="M24,0H0V24H24Z" transform="translate(4454 -750)" fill="none" />
            <path
                id="Annotation_icon"
                data-name="Annotation icon"
                d="M0,15.649v0L.008,1.565A1.563,1.563,0,0,1,1.565,0H14.084a1.567,1.567,0,0,1,1.565,1.565V7.1a5.5,5.5,0,0,0-8.325,4.72,5.577,5.577,0,0,0,.043.695H3.13L0,15.647Z"
                transform="translate(4458.176 -745.824)"
                fill={`${fill ? fill : '#cccae6'}`}
            />
            <circle
                id="Background_add"
                data-name="Background add"
                cx="4.5"
                cy="4.5"
                r="4.5"
                transform="translate(4466.5 -738.5)"
                fill={`${fill ? fill : '#cccae6'}`}
            />
            <path
                id="Add"
                d="M.795-2.213V0H-.618V-2.213h-2.2v-1.4h2.2v-2.2H.795v2.2H3v1.4Z"
                transform="translate(4471 -731)"
                fill="#0b108b"
            />
        </g>
    </svg>
);

const IconAddFavourite = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <g id="Add-Favourite" transform="translate(-4485 750)">
            <path id="Frame" d="M0,0H24V24H0Z" transform="translate(4485 -750)" fill="none" />
            <path
                id="Favourite_icon"
                data-name="Favourite icon"
                d="M3.82,19v0L5.46,11.97,0,7.24,7.19,6.63,10,0l2.81,6.63L20,7.24l-2.769,2.4a5.5,5.5,0,0,0-6.7,5.953L10,15.27,3.822,19Z"
                transform="translate(4487 -748)"
                fill="#cccae6"
            />
            <circle
                id="Background_add"
                data-name="Background add"
                cx="4.5"
                cy="4.5"
                r="4.5"
                transform="translate(4498.5 -737.5)"
                fill="#cccae6"
            />
            <path
                id="Add"
                d="M.795-2.213V0H-.618V-2.213h-2.2v-1.4h2.2v-2.2H.795v2.2H3v1.4Z"
                transform="translate(4503 -730)"
                fill="#0b108b"
            />
        </g>
    </svg>
);

const IconAI = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="none" viewBox="0 0 26 26">
        <path fill="#fff" d="M0 0h24v24H0z" />
        <g filter="url(#a)">
            <path
                fill="#fff"
                fillOpacity=".5"
                d="m14.5 9.5-2.5-5.5-2.5 5.5-5.5 2.5 5.5 2.5 2.5 5.5 2.5-5.5 5.5-2.5-5.5-2.5Z"
            />
        </g>
        <mask
            id="c"
            width="16"
            height="16"
            x="4"
            y="4"
            maskUnits="userSpaceOnUse"
            style={{ maskType: 'alpha' }}
        >
            <path
                fill="#000"
                d="m14.5 9.5-2.5-5.5-2.5 5.5-5.5 2.5 5.5 2.5 2.5 5.5 2.5-5.5 5.5-2.5-5.5-2.5Z"
            />
        </mask>
        <g filter="url(#b)" mask="url(#c)">
            <path
                fill="url(#d)"
                d="m14.5 9.5-2.5-5.5-2.5 5.5-5.5 2.5 5.5 2.5 2.5 5.5 2.5-5.5 5.5-2.5-5.5-2.5Z"
            />
            <path
                fill="url(#e)"
                fillOpacity=".1"
                d="m14.5 9.5-2.5-5.5-2.5 5.5-5.5 2.5 5.5 2.5 2.5 5.5 2.5-5.5 5.5-2.5-5.5-2.5Z"
            />
        </g>
        <defs>
            <linearGradient id="d" x1="12" x2="12" y1="4" y2="20" gradientUnits="userSpaceOnUse">
                <stop stopColor="#30588C" />
                <stop offset="1" stopColor="#32418B" />
            </linearGradient>
            <linearGradient id="e" x1="12" x2="12" y1="4" y2="20" gradientUnits="userSpaceOnUse">
                <stop stopColor="#4170A4" />
                <stop offset="1" stopColor="#444A69" />
            </linearGradient>
            <filter
                id="a"
                width="21.2"
                height="20.8"
                x="1.4"
                y="1.4"
                colorInterpolationFilters="sRGB"
                filterUnits="userSpaceOnUse"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    result="hardAlpha"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="0.6" />
                <feGaussianBlur stdDeviation="0.5" />
                <feColorMatrix values="0 0 0 0 0.756863 0 0 0 0 0.784314 0 0 0 0 0.92549 0 0 0 0.2 0" />
                <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_4_152" />
                <feColorMatrix
                    in="SourceAlpha"
                    result="hardAlpha"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="0.3" />
                <feGaussianBlur stdDeviation="0.5" />
                <feColorMatrix values="0 0 0 0 0.254902 0 0 0 0 0.439216 0 0 0 0 0.643137 0 0 0 0.2 0" />
                <feBlend in2="effect1_dropShadow_4_152" result="effect2_dropShadow_4_152" />
                <feColorMatrix
                    in="SourceAlpha"
                    result="hardAlpha"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="0.6" />
                <feGaussianBlur stdDeviation="0.8" />
                <feColorMatrix values="0 0 0 0 0.196078 0 0 0 0 0.254902 0 0 0 0 0.545098 0 0 0 0.07 0" />
                <feBlend in2="effect2_dropShadow_4_152" result="effect3_dropShadow_4_152" />
                <feColorMatrix
                    in="SourceAlpha"
                    result="hardAlpha"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dx="-0.6" dy="-0.6" />
                <feGaussianBlur stdDeviation="1" />
                <feColorMatrix values="0 0 0 0 0.756863 0 0 0 0 0.784314 0 0 0 0 0.92549 0 0 0 0.3 0" />
                <feBlend in2="effect3_dropShadow_4_152" result="effect4_dropShadow_4_152" />
                <feColorMatrix
                    in="SourceAlpha"
                    result="hardAlpha"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dx="0.6" dy="-0.6" />
                <feGaussianBlur stdDeviation="1" />
                <feColorMatrix values="0 0 0 0 0.756863 0 0 0 0 0.784314 0 0 0 0 0.92549 0 0 0 0.3 0" />
                <feBlend in2="effect4_dropShadow_4_152" result="effect5_dropShadow_4_152" />
                <feColorMatrix
                    in="SourceAlpha"
                    result="hardAlpha"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="-0.6" />
                <feGaussianBlur stdDeviation="1" />
                <feColorMatrix values="0 0 0 0 0.756863 0 0 0 0 0.784314 0 0 0 0 0.92549 0 0 0 0.25 0" />
                <feBlend in2="effect5_dropShadow_4_152" result="effect6_dropShadow_4_152" />
                <feBlend in="SourceGraphic" in2="effect6_dropShadow_4_152" result="shape" />
            </filter>
            <filter
                id="b"
                width="17"
                height="17"
                x="3.5"
                y="3.5"
                colorInterpolationFilters="sRGB"
                filterUnits="userSpaceOnUse"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feColorMatrix
                    in="SourceAlpha"
                    result="hardAlpha"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
                <feColorMatrix values="0 0 0 0 0.196078 0 0 0 0 0.271699 0 0 0 0 0.545098 0 0 0 1 0" />
                <feBlend in2="shape" mode="screen" result="effect1_innerShadow_4_152" />
                <feColorMatrix
                    in="SourceAlpha"
                    result="hardAlpha"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="1.5" />
                <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
                <feColorMatrix values="0 0 0 0 0.741176 0 0 0 0 0.780392 0 0 0 0 0.984314 0 0 0 1 0" />
                <feBlend
                    in2="effect1_innerShadow_4_152"
                    mode="hard-light"
                    result="effect2_innerShadow_4_152"
                />
                <feGaussianBlur result="effect3_foregroundBlur_4_152" stdDeviation="0.25" />
            </filter>
        </defs>
    </svg>
);

const IconAnnotation = ({ number, colour }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="36"
        height="24"
        viewBox="0 6 36 24"
    >
        <defs>
            <filter id="Ellipse_17" x="2" y="0" width="34" height="34" filterUnits="userSpaceOnUse">
                <feOffset dy="3" input="SourceAlpha" />
                <feGaussianBlur stdDeviation="3" result="blur" />
                <feFlood floodOpacity="0.161" />
                <feComposite operator="in" in2="blur" />
                <feComposite in="SourceGraphic" />
            </filter>
        </defs>
        <g id="Annotation" data-name="Group 2623" transform="translate(-1308 -590)">
            <g id="mode_comment_black_24dp" transform="translate(1308 599)">
                <path id="Path_23" data-name="Path 23" d="M24,0H0V24H24Z" fill="none" />
                <path
                    id="Path_24"
                    data-name="Path 24"
                    d="M2.008,3.565A1.563,1.563,0,0,1,3.565,2H16.084a1.569,1.569,0,0,1,1.565,1.565v9.389a1.569,1.569,0,0,1-1.565,1.565H5.13L2,17.649Z"
                    transform="translate(2.176 2.176)"
                    fill={`${colour.anno}`}
                />
            </g>
            <g transform="matrix(1, 0, 0, 1, 1308, 590)" filter="url(#Ellipse_17)">
                <circle
                    id="Ellipse_17-2"
                    data-name="Ellipse 17"
                    cx="8"
                    cy="8"
                    r="8"
                    transform="translate(11 6)"
                    fill={`${colour.circle}`}
                />
            </g>
            <text
                id="_1"
                data-name={`${number}`}
                transform="translate(1327 609)"
                fill={`${colour.text}`}
                fontSize={number < 10 ? '14' : '10'}
                fontFamily="Helvetica-Bold, Helvetica"
                fontWeight="700"
            >
                <tspan x={number < 10 ? '-3.893' : '-5.893'} y={number < 10 ? '0' : '-1'}>
                    {number}
                </tspan>
            </text>
        </g>
    </svg>
);

const IconAnnotationHover = ({ number, colour }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="36"
        height="24"
        viewBox="0 6 36 24"
    >
        <defs>
            <filter id="Ellipse_35" x="2" y="0" width="34" height="34" filterUnits="userSpaceOnUse">
                <feOffset dy="3" input="SourceAlpha" />
                <feGaussianBlur stdDeviation="3" result="blur" />
                <feFlood floodOpacity="0.161" />
                <feComposite operator="in" in2="blur" />
                <feComposite in="SourceGraphic" />
            </filter>
        </defs>
        <g id="Add-Annotation" transform="translate(-4454 759)">
            <path id="Frame" d="M24,0H0V24H24Z" transform="translate(4454 -750)" fill="none" />
            <path
                id="Annotation_icon"
                data-name="Annotation icon"
                d="M0,15.649v0L.008,1.565A1.563,1.563,0,0,1,1.565,0H14.084a1.567,1.567,0,0,1,1.565,1.565V7.1a5.5,5.5,0,0,0-8.325,4.72,5.577,5.577,0,0,0,.043.695H3.13L0,15.647Z"
                transform="translate(4458.176 -745.824)"
                fill={`${colour.anno}`}
            />
            <circle
                id="Background_add"
                data-name="Background add"
                cx="4.5"
                cy="4.5"
                r="4.5"
                transform="translate(4466.5 -738.5)"
                fill="#cccae6"
            />
            <path
                id="Add"
                d="M.795-2.213V0H-.618V-2.213h-2.2v-1.4h2.2v-2.2H.795v2.2H3v1.4Z"
                transform="translate(4471 -731)"
                fill={`${number}`}
            />
            <g transform="matrix(1, 0, 0, 1, 4454, -759)" filter="url(#Ellipse_35)">
                <circle
                    id="Ellipse_35-2"
                    data-name="Ellipse 35"
                    cx="8"
                    cy="8"
                    r="8"
                    transform="translate(11 6)"
                    fill={`${colour.circle}`}
                />
            </g>
            <text
                id="_1"
                data-name={`${number}`}
                transform="translate(4473 -740)"
                fill={`${colour.text}`}
                fontSize={number < 10 ? '14' : '10'}
                fontFamily="Helvetica-Bold, Helvetica"
                fontWeight="700"
            >
                <tspan x={number < 10 ? '-3.893' : '-5.893'} y={number < 10 ? '0' : '-1'}>
                    {number}
                </tspan>
            </text>
        </g>
    </svg>
);

const IconBrowse = () => (
    <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <title>Icon / Browse</title>
        <g id="Icon-/-Browse" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <path
                d="M9.39511224,5 L11.373446,6.95621989 L18.3767776,6.95621989 C19.0456205,6.95621989 19.6078541,7.18357369 20.0634782,7.63828128 C20.5190874,8.09297413 20.746892,8.64684362 20.746892,9.29988975 L4.37011448,9.29988975 L4.37011448,17.7188342 L6.46605849,11.0686638 L22,11.0686638 L19.8233611,17.9774069 C19.6030021,18.6522531 19.2588543,19.1580635 18.7909176,19.4948381 C18.3229959,19.8316127 17.7393719,20 17.0400456,20 L4.37011448,20 C3.70969353,20 3.14956921,19.7726536 2.68974153,19.3179607 C2.22991384,18.8632679 2,18.3093984 2,17.6563523 L2,7.34364774 C2,6.68227364 2.22991384,6.12631847 2.68974153,5.67578224 C3.14956921,5.22526075 3.70969353,5 4.37011448,5 L9.39511224,5 Z M9.25,13.5 C8.55964406,13.5 8,14.0596441 8,14.75 C8,15.4403559 8.55964406,16 9.25,16 C9.94035594,16 10.5,15.4403559 10.5,14.75 C10.5,14.0596441 9.94035594,13.5 9.25,13.5 Z M13.25,13.5 C12.5596441,13.5 12,14.0596441 12,14.75 C12,15.4403559 12.5596441,16 13.25,16 C13.9403559,16 14.5,15.4403559 14.5,14.75 C14.5,14.0596441 13.9403559,13.5 13.25,13.5 Z M17.25,13.5 C16.5596441,13.5 16,14.0596441 16,14.75 C16,15.4403559 16.5596441,16 17.25,16 C17.9403559,16 18.5,15.4403559 18.5,14.75 C18.5,14.0596441 17.9403559,13.5 17.25,13.5 Z"
                id="Combined-Shape"
                fill="#000000"
                fillRule="nonzero"
            ></path>
        </g>
    </svg>
);

const IconCollection = () => (
    <svg
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        viewBox="0 0 24 24"
    >
        <path
            className="cls-1"
            d="M19,2.8h0s0,0,0,0c0,0-.1,0-.2-.1,0,0-.1,0-.2-.1,0,0-.2-.1-.3-.2,0,0-.1,0-.2,0-.1,0-.2,0-.4-.1,0,0-.1,0-.2,0-.2,0-.4,0-.6,0H7c-.2,0-.4,0-.6,0,0,0-.1,0-.2,0-.1,0-.2,0-.4.1,0,0-.1,0-.2,0-.1,0-.2.1-.3.2,0,0-.1,0-.2.1,0,0-.1,0-.2.1,0,0,0,0,0,0-.6.5-1,1.3-1,2.2v14c0,1.7,1.3,3,3,3h10c1.7,0,3-1.3,3-3V5c0-.9-.4-1.7-1-2.2ZM6,13.5h4v-3.5h2v3.5h.8s0-4,0-4h2v4s1.3,0,1.3,0l-.9-2.1,1.7-.8,1.1,2.8v1H6v-1ZM6,8.5v-1h.6v-.4s0-2.6,0-2.6h1.9v2.9h.6v-3.5h2v3.5s1.3,0,1.3,0l-1-2.7,1.9-.8,1.3,3.4h0c0,0,3.2,0,3.2,0v1H6ZM17,20H7c-.6,0-1-.4-1-1h0s.5,0,.5,0v-2.2h2v2.2s.8,0,.8,0v-3.5h2v3.5s.7,0,.7,0v-3.5h2v3.5h4c0,.6-.4,1-1,1Z"
        />
    </svg>
);

const IconDate = () => (
    <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <title>Icon / Date</title>
        <g id="Icon-/-Date" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g
                id="date_range_FILL0_wght400_GRAD0_opsz24"
                transform="translate(4, 3)"
                fill="#000000"
                fillRule="nonzero"
            >
                <path
                    d="M4.44444444,10.8 C4.19259259,10.8 3.98148148,10.71375 3.81111111,10.54125 C3.64074074,10.36875 3.55555556,10.155 3.55555556,9.9 C3.55555556,9.645 3.64074074,9.43125 3.81111111,9.25875 C3.98148148,9.08625 4.19259259,9 4.44444444,9 C4.6962963,9 4.90740741,9.08625 5.07777778,9.25875 C5.24814815,9.43125 5.33333333,9.645 5.33333333,9.9 C5.33333333,10.155 5.24814815,10.36875 5.07777778,10.54125 C4.90740741,10.71375 4.6962963,10.8 4.44444444,10.8 Z M8,10.8 C7.74814815,10.8 7.53703704,10.71375 7.36666667,10.54125 C7.1962963,10.36875 7.11111111,10.155 7.11111111,9.9 C7.11111111,9.645 7.1962963,9.43125 7.36666667,9.25875 C7.53703704,9.08625 7.74814815,9 8,9 C8.25185185,9 8.46296296,9.08625 8.63333333,9.25875 C8.8037037,9.43125 8.88888889,9.645 8.88888889,9.9 C8.88888889,10.155 8.8037037,10.36875 8.63333333,10.54125 C8.46296296,10.71375 8.25185185,10.8 8,10.8 Z M11.5555556,10.8 C11.3037037,10.8 11.0925926,10.71375 10.9222222,10.54125 C10.7518519,10.36875 10.6666667,10.155 10.6666667,9.9 C10.6666667,9.645 10.7518519,9.43125 10.9222222,9.25875 C11.0925926,9.08625 11.3037037,9 11.5555556,9 C11.8074074,9 12.0185185,9.08625 12.1888889,9.25875 C12.3592593,9.43125 12.4444444,9.645 12.4444444,9.9 C12.4444444,10.155 12.3592593,10.36875 12.1888889,10.54125 C12.0185185,10.71375 11.8074074,10.8 11.5555556,10.8 Z M1.77777778,18 C1.28888889,18 0.87037037,17.82375 0.522222222,17.47125 C0.174074074,17.11875 0,16.695 0,16.2 L0,3.6 C0,3.105 0.174074074,2.68125 0.522222222,2.32875 C0.87037037,1.97625 1.28888889,1.8 1.77777778,1.8 L2.66666667,1.8 L2.66666667,0 L4.44444444,0 L4.44444444,1.8 L11.5555556,1.8 L11.5555556,0 L13.3333333,0 L13.3333333,1.8 L14.2222222,1.8 C14.7111111,1.8 15.1296296,1.97625 15.4777778,2.32875 C15.8259259,2.68125 16,3.105 16,3.6 L16,16.2 C16,16.695 15.8259259,17.11875 15.4777778,17.47125 C15.1296296,17.82375 14.7111111,18 14.2222222,18 L1.77777778,18 Z M1.77777778,16.2 L14.2222222,16.2 L14.2222222,7.2 L1.77777778,7.2 L1.77777778,16.2 Z M1.77777778,5.4 L14.2222222,5.4 L14.2222222,3.6 L1.77777778,3.6 L1.77777778,5.4 Z M1.81666667,5.4 L1.81666667,3.6 L1.81666667,5.4 Z"
                    id="Shape"
                ></path>
            </g>
        </g>
    </svg>
);

const IconDateSelect = () => (
    <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <title>Icon / Date Select</title>
        <g id="Icon-/-Date-Select" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g
                id="event_FILL0_wght400_GRAD0_opsz24-2"
                transform="translate(3, 2)"
                fill="#000000"
                fillRule="nonzero"
            >
                <path
                    d="M11.5,16 C10.8,16 10.2083333,15.7583333 9.725,15.275 C9.24166667,14.7916667 9,14.2 9,13.5 C9,12.8 9.24166667,12.2083333 9.725,11.725 C10.2083333,11.2416667 10.8,11 11.5,11 C12.2,11 12.7916667,11.2416667 13.275,11.725 C13.7583333,12.2083333 14,12.8 14,13.5 C14,14.2 13.7583333,14.7916667 13.275,15.275 C12.7916667,15.7583333 12.2,16 11.5,16 Z M2,20 C1.45,20 0.979166667,19.8041667 0.5875,19.4125 C0.195833333,19.0208333 0,18.55 0,18 L0,4 C0,3.45 0.195833333,2.97916667 0.5875,2.5875 C0.979166667,2.19583333 1.45,2 2,2 L3,2 L3,0 L5,0 L5,2 L13,2 L13,0 L15,0 L15,2 L16,2 C16.55,2 17.0208333,2.19583333 17.4125,2.5875 C17.8041667,2.97916667 18,3.45 18,4 L18,18 C18,18.55 17.8041667,19.0208333 17.4125,19.4125 C17.0208333,19.8041667 16.55,20 16,20 L2,20 Z M2,18 L16,18 L16,8 L2,8 L2,18 Z M2,6 L16,6 L16,4 L2,4 L2,6 Z M2.0375,6 L2.0375,4 L2.0375,6 Z"
                    id="Shape"
                ></path>
            </g>
        </g>
    </svg>
);

const IconDefault = () => (
    <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <title>Icon / Default</title>
        <g id="Icon-/-Default" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g
                id="manage_history_FILL1_wght400_GRAD0_opsz24"
                transform="translate(4, 4)"
                fill="#000000"
                fillRule="nonzero"
            >
                <path
                    d="M0,6 L0,0.857142857 L1.72869148,0.857142857 L1.72869148,2.87142857 C2.46338535,1.95714286 3.36014406,1.25 4.41896759,0.75 C5.47779112,0.25 6.59783914,0 7.77911164,0 C9.93997599,0 11.7767107,0.75 13.2893157,2.25 C14.8019208,3.75 15.5582233,5.57142857 15.5582233,7.71428571 L13.8295318,7.71428571 C13.8295318,6.04285714 13.242497,4.625 12.0684274,3.46071429 C10.8943577,2.29642857 9.46458583,1.71428571 7.77911164,1.71428571 C6.78511405,1.71428571 5.85594238,1.94285714 4.99159664,2.4 C4.1272509,2.85714286 3.3997599,3.48571429 2.80912365,4.28571429 L5.18607443,4.28571429 L5.18607443,6 L0,6 Z M0.0432172869,8.57142857 L1.81512605,8.57142857 C1.9879952,9.9 2.53901561,11.025 3.46818727,11.9464286 C4.39735894,12.8678571 5.51020408,13.4285714 6.80672269,13.6285714 L7.84393758,15.4285714 C5.85594238,15.4285714 4.11284514,14.775 2.61464586,13.4678571 C1.11644658,12.1607143 0.259303721,10.5285714 0.0432172869,8.57142857 Z M8.94597839,10.0714286 L6.91476591,8.05714286 L6.91476591,3.42857143 L8.64345738,3.42857143 L8.64345738,7.37142857 L9.85354142,8.57142857 L8.94597839,10.0714286 Z M12.9435774,18 L12.6842737,16.7142857 C12.5114046,16.6428571 12.3493397,16.5678571 12.1980792,16.4892857 C12.0468187,16.4107143 11.8919568,16.3142857 11.7334934,16.2 L10.4801921,16.5857143 L9.61584634,15.1285714 L10.6098439,14.2714286 C10.5810324,14.0857143 10.5666267,13.9 10.5666267,13.7142857 C10.5666267,13.5285714 10.5810324,13.3428571 10.6098439,13.1571429 L9.61584634,12.3 L10.4801921,10.8428571 L11.7334934,11.2285714 C11.8919568,11.1142857 12.0468187,11.0178571 12.1980792,10.9392857 C12.3493397,10.8607143 12.5114046,10.7857143 12.6842737,10.7142857 L12.9435774,9.42857143 L14.6722689,9.42857143 L14.9315726,10.7142857 C15.1044418,10.7857143 15.270108,10.8678571 15.4285714,10.9607143 C15.5870348,11.0535714 15.7382953,11.1571429 15.8823529,11.2714286 L17.1356543,10.8428571 L18,12.3428571 L17.0060024,13.2 C17.0348139,13.3857143 17.0492197,13.5642857 17.0492197,13.7357143 C17.0492197,13.9071429 17.0348139,14.0857143 17.0060024,14.2714286 L18,15.1285714 L17.1356543,16.5857143 L15.8823529,16.2 C15.7238896,16.3142857 15.5690276,16.4107143 15.4177671,16.4892857 C15.2665066,16.5678571 15.1044418,16.6428571 14.9315726,16.7142857 L14.6722689,18 L12.9435774,18 Z M13.8079232,15.4285714 C14.2833133,15.4285714 14.6902761,15.2607143 15.0288115,14.925 C15.3673469,14.5892857 15.5366146,14.1857143 15.5366146,13.7142857 C15.5366146,13.2428571 15.3673469,12.8392857 15.0288115,12.5035714 C14.6902761,12.1678571 14.2833133,12 13.8079232,12 C13.332533,12 12.9255702,12.1678571 12.5870348,12.5035714 C12.2484994,12.8392857 12.0792317,13.2428571 12.0792317,13.7142857 C12.0792317,14.1857143 12.2484994,14.5892857 12.5870348,14.925 C12.9255702,15.2607143 13.332533,15.4285714 13.8079232,15.4285714 Z"
                    id="Shape"
                ></path>
            </g>
        </g>
    </svg>
);

const IconDocument = () => (
    <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <title>Icon / Doc Small</title>
        <g id="Icon-/-Doc-Small" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <path
                d="M6.84745763,22 C6.04896422,22 5.3747646,21.7196621 4.82485876,21.1589862 C4.27495292,20.5983103 4,19.9109063 4,19.0967742 L4,4.90322581 C4,4.0890937 4.27495292,3.40168971 4.82485876,2.84101382 C5.3747646,2.28033794 6.04896422,2 6.84745763,2 L14.1242938,2 L20,7.99078341 L20,19.0967742 C20,19.9109063 19.7250471,20.5983103 19.1751412,21.1589862 C18.6252354,21.7196621 17.9510358,22 17.1525424,22 L6.84745763,22 Z M12,10 L17,10 L12,5 L12,10 Z"
                id="Shape"
                fill="#000000"
                fillRule="nonzero"
            ></path>
        </g>
    </svg>
);

const IconDocumentSearch = () => (
    <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <title>Icon / Document Search</title>
        <g id="Icon-/-Document-Search" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g
                id="plagiarism_FILL0_wght300_GRAD0_opsz24"
                transform="translate(4, 2)"
                fill="#000000"
                fillRule="nonzero"
            >
                <path
                    d="M7.20818403,14.6963281 C7.54185625,14.6963281 7.865964,14.6501087 8.18050727,14.5576699 C8.49503276,14.4652135 8.78905152,14.3332921 9.06256354,14.1619057 L11.8195061,16.8825707 L12.9435898,15.7732784 L10.1866473,13.0526133 C10.3739901,12.7894547 10.5110839,12.5009978 10.5979287,12.1872426 C10.6847556,11.8734698 10.7281691,11.5519427 10.7281691,11.2226611 C10.7281691,10.2793428 10.3910835,9.48211267 9.71691239,8.83097061 C9.04272348,8.179811 8.22425853,7.8542312 7.26151754,7.8542312 C6.29879433,7.8542312 5.48033827,8.18688997 4.80614935,8.85220751 C4.13196044,9.51752505 3.79486598,10.3252202 3.79486598,11.2752928 C3.79486598,12.225348 4.12477819,13.0330343 4.78460262,13.6983518 C5.44442704,14.3636694 6.25228751,14.6963281 7.20818403,14.6963281 L7.20818403,14.6963281 Z M7.26151754,13.1174029 C6.74869805,13.1174029 6.30938103,12.9369025 5.94356648,12.5759015 C5.57773415,12.2149006 5.39481798,11.7813643 5.39481798,11.2752928 C5.39481798,10.7692038 5.57773415,10.3356588 5.94356648,9.97465783 C6.30938103,9.61365688 6.74869805,9.4331564 7.26151754,9.4331564 C7.7743548,9.4331564 8.21368071,9.61365688 8.57949526,9.97465783 C8.94530982,10.3356588 9.12821709,10.7692038 9.12821709,11.2752928 C9.12821709,11.7813643 8.94530982,12.2149006 8.57949526,12.5759015 C8.21368071,12.9369025 7.7743548,13.1174029 7.26151754,13.1174029 Z M1.92821976,20 C1.38940908,20 0.933336444,19.815789 0.560001867,19.447367 C0.186667289,19.0789449 0,18.6288736 0,18.0971529 L0,1.90284711 C0,1.37112642 0.186667289,0.921055055 0.560001867,0.552633033 C0.933336444,0.184211011 1.38940908,0 1.92821976,0 L10.4000347,0 L16,5.5262777 L16,18.0971529 C16,18.6288736 15.8133327,19.0789449 15.4399981,19.447367 C15.0666636,19.815789 14.6105909,20 14.0717802,20 L1.92821976,20 Z M9.600032,6.31575346 L9.600032,1.57892521 L1.92821976,1.57892521 C1.84615726,1.57892521 1.77093035,1.61266214 1.70253901,1.680136 C1.63416545,1.74762741 1.59997867,1.82186444 1.59997867,1.90284711 L1.59997867,18.0971529 C1.59997867,18.1781356 1.63416545,18.2523726 1.70253901,18.319864 C1.77093035,18.3873379 1.84615726,18.4210748 1.92821976,18.4210748 L14.0717802,18.4210748 C14.1538427,18.4210748 14.2290697,18.3873379 14.297461,18.319864 C14.3658346,18.2523726 14.4000213,18.1781356 14.4000213,18.0971529 L14.4000213,6.31575346 L9.600032,6.31575346 Z M1.6399788,1.57892521 L1.6399788,6.31575346 L1.6399788,1.57892521 L1.6399788,18.4210748 L1.6399788,1.57892521 Z"
                    id="Shape"
                ></path>
            </g>
        </g>
    </svg>
);

const IconDropdownChevron = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
        <g transform="translate(-19118 -7753)">
            <rect width="12" height="12" transform="translate(19118 7753)" fill="none" />
            <path
                d="M246,434.5l-6-5.512,1.075-.988L246,432.548l4.925-4.525,1.075.988Z"
                transform="translate(18878 7328.254)"
                fill="#505fab"
            />
        </g>
    </svg>
);

const IconFavourite = ({ colour, background }) => (
    <svg
        id="Added-Favourite"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
    >
        <path id="Frame" d="M0,0H24V24H0Z" fill="none" />
        <path
            id="Favourite"
            d="M12,17.27,18.18,21l-1.64-7.03L22,9.24l-7.19-.61L12,2,9.19,8.63,2,9.24l5.46,4.73L5.82,21Z"
            fill={colour}
            stroke={background}
            strokeWidth={2}
        />
    </svg>
);

const IconFilter = () => (
    <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <title>Icon / FIlter</title>
        <g id="Icon-/-FIlter" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g
                id="filter_alt_24dp_FILL0_wght400_GRAD0_opsz24-2"
                transform="translate(4, 5)"
                fill="#000000"
                fillRule="nonzero"
            >
                <path
                    d="M7.02058824,16 C6.7372549,16 6.4997549,15.9041667 6.30808824,15.7125 C6.11642157,15.5208333 6.02058824,15.2833333 6.02058824,15 L6.02058824,9 L0.220588235,1.6 C-0.0294117647,1.26666667 -0.0669117647,0.916666667 0.108088235,0.55 C0.283088235,0.183333333 0.587254902,0 1.02058824,0 L15.0205882,0 C15.4539216,0 15.7580882,0.183333333 15.9330882,0.55 C16.1080882,0.916666667 16.0705882,1.26666667 15.8205882,1.6 L10.0205882,9 L10.0205882,15 C10.0205882,15.2833333 9.9247549,15.5208333 9.73308824,15.7125 C9.54142157,15.9041667 9.30392157,16 9.02058824,16 L7.02058824,16 Z M8.02058824,8.3 L12.9705882,2 L3.07058824,2 L8.02058824,8.3 Z"
                    id="Shape"
                ></path>
            </g>
        </g>
    </svg>
);

const IconFilterDocument = () => (
    <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <title>Icon / Filter Doc</title>
        <g id="Icon-/-Filter-Doc" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g
                id="manage_search_FILL0_wght300_GRAD0_opsz24"
                transform="translate(2, 5)"
                fill="#000000"
                fillRule="nonzero"
            >
                <path
                    d="M0,11.5 L10.25,11.5 L10.25,13 L0,13 L0,11.5 Z M0,7.5 L0,6 L5,6 L5,7.5 L0,7.5 Z M0,2.24999479 L0,0.749994792 L5,0.749994792 L5,2.24999479 L0,2.24999479 Z M18.8907076,13 L14.8178022,8.83954933 C14.4169941,9.13956169 13.9800894,9.36803764 13.5070882,9.52497719 C13.0340694,9.68191673 12.5532962,9.7603865 12.0647686,9.7603865 C10.7458528,9.7603865 9.6215955,9.28608314 8.69199656,8.33747641 C7.76239762,7.38886968 7.29759815,6.23644196 7.29759815,4.88019325 C7.29759815,3.5239626 7.76263446,2.37153488 8.69270709,1.4229101 C9.62276217,0.474303365 10.7475809,0 12.0671633,0 C13.3867633,0 14.5107926,0.474303365 15.4392512,1.4229101 C16.3677273,2.37153488 16.8319653,3.52222926 16.8319653,4.87499323 C16.8319653,5.37777032 16.7557195,5.8725578 16.6032279,6.35935566 C16.4507187,6.84617158 16.2253409,7.2923533 15.9270945,7.69790082 L20,11.8583515 L18.8907076,13 Z M12.0647686,8.1354339 C12.9504025,8.1354339 13.703194,7.81946036 14.323143,7.18751328 C14.9430744,6.5555662 15.2530401,5.78645953 15.2530401,4.88019325 C15.2530401,3.97394503 14.9430744,3.20484738 14.323143,2.5729003 C13.703194,1.94095323 12.9504025,1.62497969 12.0647686,1.62497969 C11.1791522,1.62497969 10.4263695,1.94095323 9.80642054,2.5729003 C9.18647154,3.20484738 8.87649704,3.97394503 8.87649704,4.88019325 C8.87649704,5.78645953 9.18647154,6.5555662 9.80642054,7.18751328 C10.4263695,7.81946036 11.1791522,8.1354339 12.0647686,8.1354339 Z"
                    id="Shape"
                ></path>
            </g>
        </g>
    </svg>
);

const IconGrip = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
        <path data-name="Path 109" d="M0,0H18V18H0Z" fill="none" />
        <path
            data-name="Path 110"
            d="M10,14.5A1.5,1.5,0,1,1,8.5,13,1.5,1.5,0,0,1,10,14.5Zm-1.5-6A1.5,1.5,0,1,0,10,10,1.5,1.5,0,0,0,8.5,8.5ZM8.5,4A1.5,1.5,0,1,0,10,5.5,1.5,1.5,0,0,0,8.5,4ZM13,7a1.5,1.5,0,1,0-1.5-1.5A1.5,1.5,0,0,0,13,7Zm0,1.5A1.5,1.5,0,1,0,14.5,10,1.5,1.5,0,0,0,13,8.5ZM13,13a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,13,13Z"
            transform="translate(-1.75 -1)"
            fill="#8b8b8b"
        />
    </svg>
);

const IconGroup = (fill) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 -2 24 24">
        <path d="M24,0H0V24H24Z" fill="none" />
        <path
            d="M40,272v-4a1.75,1.75,0,0,1,1.75-1.75h3.525a1.666,1.666,0,0,1,.812.212,2.023,2.023,0,0,1,.663.587,4.96,4.96,0,0,0,1.85,1.625,5.245,5.245,0,0,0,6.675-1.625,2.07,2.07,0,0,1,.65-.587,1.6,1.6,0,0,1,.8-.212H60.25A1.75,1.75,0,0,1,62,268v4H55.5v-2.975a6.492,6.492,0,0,1-2.062,1.275,6.692,6.692,0,0,1-2.438.45,6.593,6.593,0,0,1-2.425-.45,6.839,6.839,0,0,1-2.075-1.275V272Zm11-4.25a3.683,3.683,0,0,1-1.688-.413A3.476,3.476,0,0,1,48,266.2a3.276,3.276,0,0,0-.963-.925,3.542,3.542,0,0,0-1.212-.475,4.772,4.772,0,0,1,2.275-1.15,11.644,11.644,0,0,1,2.9-.4,11.79,11.79,0,0,1,2.913.4A4.782,4.782,0,0,1,56.2,264.8a3.542,3.542,0,0,0-1.213.475,3.276,3.276,0,0,0-.963.925,3.476,3.476,0,0,1-1.312,1.138A3.733,3.733,0,0,1,51,267.75Zm-8-3.25a2.753,2.753,0,1,1,1.95-.812A2.645,2.645,0,0,1,43,264.5Zm16,0a2.753,2.753,0,1,1,1.95-.812A2.645,2.645,0,0,1,59,264.5Zm-8-3a2.753,2.753,0,1,1,1.95-.813A2.645,2.645,0,0,1,51,261.5Z"
            transform="translate(-39 -252)"
            fill={fill}
        />
    </svg>
);

const IconNewSearch = () => (
    <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
        <g fill="#0C008B" fillRule="nonzero">
            <path d="M11.142 11.958 8.05 8.867a3.555 3.555 0 0 1-2.217.758c-1.06 0-1.956-.367-2.69-1.101s-1.101-1.63-1.101-2.69.367-1.957 1.1-2.691c.735-.734 1.632-1.101 2.691-1.101 1.06 0 1.957.367 2.691 1.1.734.735 1.101 1.632 1.101 2.691a3.555 3.555 0 0 1-.758 2.217l3.091 3.092-.816.816zm-5.309-3.5c.73 0 1.35-.255 1.86-.765s.765-1.13.765-1.86c0-.729-.255-1.349-.765-1.859a2.531 2.531 0 0 0-1.86-.766c-.729 0-1.349.256-1.859.766s-.766 1.13-.766 1.86c0 .729.256 1.348.766 1.859.51.51 1.13.765 1.86.765z" />
            <path d="M5.28 6.386H4.084V5.281h1.198V4.083h1.105v1.198h1.197v1.105H6.386v1.197H5.281z" />
        </g>
    </svg>
);

const IconOpenInNew = () => (
    <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <title>Icon / Open in new</title>
        <g id="Icon-/-Open-in-new" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g
                id="open_in_new_24dp_FILL0_wght400_GRAD0_opsz24"
                transform="translate(3, 3)"
                fill="#000000"
                fillRule="nonzero"
            >
                <path
                    d="M2,18 C1.45,18 0.979166667,17.8041667 0.5875,17.4125 C0.195833333,17.0208333 0,16.55 0,16 L0,2 C0,1.45 0.195833333,0.979166667 0.5875,0.5875 C0.979166667,0.195833333 1.45,0 2,0 L9,0 L9,2 L2,2 L2,16 L16,16 L16,9 L18,9 L18,16 C18,16.55 17.8041667,17.0208333 17.4125,17.4125 C17.0208333,17.8041667 16.55,18 16,18 L2,18 Z M6.7,12.7 L5.3,11.3 L14.6,2 L11,2 L11,0 L18,0 L18,7 L16,7 L16,3.4 L6.7,12.7 Z"
                    id="Shape"
                ></path>
            </g>
        </g>
    </svg>
);

const IconOswaldPointLeft = (size) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size.width}
        height={size.height}
        viewBox="0 0 4123.75 3567.023"
    >
        <g id="oswold-pointing-left-light" transform="translate(0.001)">
            <g id="Group_2071" data-name="Group 2071" transform="translate(2904.695 3254.159)">
                <path
                    id="Line_53"
                    data-name="Line 53"
                    d="M-1,167.029H86.274V0H-1Z"
                    transform="translate(203.585 0)"
                    fill="#4c5658"
                />
                <path
                    id="Line_54"
                    data-name="Line 54"
                    d="M74.907,149.1,135.645,42.8,59.87-.5-.868,105.8Z"
                    transform="translate(148.465 145.876)"
                    fill="#4c5658"
                />
                <path
                    id="Line_55"
                    data-name="Line 55"
                    d="M36.484,184.471,264.253,78.179,227.346-.906-.423,105.386Z"
                    transform="translate(0.423 128.393)"
                    fill="#4c5658"
                />
                <path
                    id="Line_56"
                    data-name="Line 56"
                    d="M166.494,179.077l46.855-73.629L46.318-.844-.537,72.785Z"
                    transform="translate(223.332 131.059)"
                    fill="#4c5658"
                />
            </g>
            <g id="Group_2072" data-name="Group 2072" transform="translate(2236.572 3112.359)">
                <path
                    id="Line_53-2"
                    data-name="Line 53"
                    d="M76.345,328.688,228.191,40.182,150.961-.466-.885,288.04Z"
                    transform="translate(208.492 0.466)"
                    fill="#4c5658"
                />
                <path
                    id="Line_54-2"
                    data-name="Line 54"
                    d="M74.907,149.1,135.645,42.8,59.87-.5-.868,105.8Z"
                    transform="translate(148.465 287.676)"
                    fill="#4c5658"
                />
                <path
                    id="Line_55-2"
                    data-name="Line 55"
                    d="M36.484,184.471,264.253,78.179,227.346-.906-.423,105.386Z"
                    transform="translate(0.423 270.193)"
                    fill="#4c5658"
                />
                <path
                    id="Line_56-2"
                    data-name="Line 56"
                    d="M166.494,179.077l46.855-73.629L46.318-.844-.537,72.785Z"
                    transform="translate(223.332 272.859)"
                    fill="#4c5658"
                />
            </g>
            <path
                id="Path_94"
                data-name="Path 94"
                d="M14218.313,11817.688s-1495,127.313-2084-605.625c-179.125,210.063-427.687,1049.313-427.687,1049.313s-1518.062-452.062-1612.062-554c75.375,350.688,84.875,473.313,534,675.313,104,46.625,179.563,66,357.875,135.188.125,0,.313,53.438,0,53.125-197.437-35.187-512-190.375-749.5-334.125-.875,153.125,46.25,527.313,1003.25,680.688v63.688s-555.875-94.5-828.375-289.562c31.063,387.5,536.813,587,536.813,587s354.75,160.75,758,106.625c626.125,1472.688,2360.938,1020.063,2360.938,1020.063s-244.812-288.312-315.937-870.312S14218.313,11817.688,14218.313,11817.688Z"
                transform="translate(-10094.563 -11212.063)"
                fill="#73c7c6"
            />
            <g id="Group_2070" data-name="Group 2070" transform="translate(1731.155 741.122)">
                <path
                    id="Union_3"
                    data-name="Union 3"
                    d="M0,432.746C0,671.751,193.743,865.5,432.749,865.5A431.523,431.523,0,0,0,746.565,730.743c23.67,220.881,210.657,392.893,437.839,392.893,243.183,0,440.349-197.143,440.349-440.336S1427.587,242.953,1184.4,242.953a439.091,439.091,0,0,0-321.725,139.68C837.821,167.23,654.807,0,432.749,0,193.743,0,0,193.753,0,432.746Z"
                    transform="translate(1624.753 1123.636) rotate(180)"
                    fill="#fff"
                />
                <path
                    id="Path_95"
                    data-name="Path 95"
                    d="M128.339,342.722c70.88,0,128.34-84.2,128.34-155.076S199.22,0,128.34,0,0,116.766,0,187.646,57.459,342.722,128.339,342.722Z"
                    transform="translate(758.783 1221.541) rotate(-166)"
                    fill="#fff"
                />
                <ellipse
                    id="Ellipse_9"
                    data-name="Ellipse 9"
                    cx="113.885"
                    cy="113.884"
                    rx="113.885"
                    ry="113.884"
                    transform="translate(1002.185 409.982)"
                    fill="#4b5459"
                />
                <path
                    id="Ellipse_9_-_Outline"
                    data-name="Ellipse 9 - Outline"
                    d="M113.885,1A113.725,113.725,0,0,0,91.133,3.293,112.261,112.261,0,0,0,50.77,20.278a113.216,113.216,0,0,0-40.9,49.667A112.305,112.305,0,0,0,3.293,91.133a113.993,113.993,0,0,0,0,45.5A112.26,112.26,0,0,0,20.278,177a113.217,113.217,0,0,0,49.667,40.9,112.311,112.311,0,0,0,21.188,6.577,114,114,0,0,0,45.5,0A112.261,112.261,0,0,0,177,207.49a113.216,113.216,0,0,0,40.9-49.667,112.305,112.305,0,0,0,6.577-21.188,113.993,113.993,0,0,0,0-45.5A112.26,112.26,0,0,0,207.491,50.77a113.217,113.217,0,0,0-49.667-40.9,112.311,112.311,0,0,0-21.188-6.577A113.725,113.725,0,0,0,113.885,1m0-1A113.884,113.884,0,1,1,0,113.884,113.884,113.884,0,0,1,113.885,0Z"
                    transform="translate(1002.185 409.982)"
                    fill="#707070"
                />
                <ellipse
                    id="Ellipse_10"
                    data-name="Ellipse 10"
                    cx="113.885"
                    cy="113.884"
                    rx="113.885"
                    ry="113.884"
                    transform="translate(197.401 136.661)"
                    fill="#4b5459"
                />
                <path
                    id="Ellipse_10_-_Outline"
                    data-name="Ellipse 10 - Outline"
                    d="M113.885,1A113.725,113.725,0,0,0,91.133,3.293,112.261,112.261,0,0,0,50.77,20.278a113.216,113.216,0,0,0-40.9,49.667A112.305,112.305,0,0,0,3.293,91.133a113.993,113.993,0,0,0,0,45.5A112.26,112.26,0,0,0,20.278,177a113.217,113.217,0,0,0,49.667,40.9,112.311,112.311,0,0,0,21.188,6.577,114,114,0,0,0,45.5,0A112.261,112.261,0,0,0,177,207.49a113.216,113.216,0,0,0,40.9-49.667,112.305,112.305,0,0,0,6.577-21.188,113.993,113.993,0,0,0,0-45.5A112.26,112.26,0,0,0,207.491,50.77a113.217,113.217,0,0,0-49.667-40.9,112.311,112.311,0,0,0-21.188-6.577A113.725,113.725,0,0,0,113.885,1m0-1A113.884,113.884,0,1,1,0,113.884,113.884,113.884,0,0,1,113.885,0Z"
                    transform="translate(197.401 136.661)"
                    fill="#707070"
                />
            </g>
        </g>
    </svg>
);

const IconPrivate = (fill) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 -2 24 24">
        <path d="M24,0H0V24H24Z" fill="none" />
        <path
            d="M165.668,280.314a2.548,2.548,0,1,1,1.913-.744A2.59,2.59,0,0,1,165.668,280.314ZM160,286v-1.665a1.949,1.949,0,0,1,.337-1.151,2.161,2.161,0,0,1,.868-.726,13.318,13.318,0,0,1,2.276-.8,9.2,9.2,0,0,1,2.188-.266,8.813,8.813,0,0,1,2.179.275,15.092,15.092,0,0,1,2.267.788,2.136,2.136,0,0,1,.886.726,1.949,1.949,0,0,1,.337,1.151V286Z"
            transform="translate(-153.668 -268)"
            fill={fill}
        />
    </svg>
);

const IconProject = (fill) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 -2 24 24">
        <path d="M24,0H0V24H24Z" fill="none" />
        <path
            d="M67.4,164.367a1.467,1.467,0,0,1-1.078-.454,1.488,1.488,0,0,1-.451-1.086V154.9a1.54,1.54,0,0,1,1.529-1.529h3.125V151.91a1.487,1.487,0,0,1,.451-1.086,1.466,1.466,0,0,1,1.078-.454h3.621a1.466,1.466,0,0,1,1.078.454,1.487,1.487,0,0,1,.451,1.086v1.459h3.126a1.487,1.487,0,0,1,1.086.451,1.466,1.466,0,0,1,.454,1.078v7.929a1.55,1.55,0,0,1-1.54,1.54Zm4.655-11h3.621V151.91H72.053Z"
            transform="translate(-61.869 -145.369)"
            fill={fill}
        />
    </svg>
);

const IconRefine = () => (
    <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M6.417 12.25v-3.5h1.166v1.167h4.667v1.166H7.583v1.167H6.417zM1.75 11.083V9.917h3.5v1.166h-3.5zM4.083 8.75V7.583H1.75V6.417h2.333V5.25H5.25v3.5H4.083zm2.334-1.167V6.417h5.833v1.166H6.417zM8.75 5.25v-3.5h1.167v1.167h2.333v1.166H9.917V5.25H8.75zm-7-1.167V2.917h5.833v1.166H1.75z"
            fill="#0C008B"
            fillRule="nonzero"
        />
    </svg>
);

const IconRerun = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <g fill="#30588C" fillRule="nonzero">
            <path d="M10 18.333c-1.414 0-2.715-.322-3.901-.966a8.443 8.443 0 0 1-2.917-2.575v2.026H1.667v-4.545h4.545v1.515H4.337a6.86 6.86 0 0 0 2.396 2.197c.991.555 2.08.833 3.267.833.947 0 1.834-.18 2.661-.54a6.93 6.93 0 0 0 2.16-1.458 6.93 6.93 0 0 0 1.457-2.159c.36-.827.54-1.714.54-2.661h1.515a8.09 8.09 0 0 1-.653 3.239 8.434 8.434 0 0 1-1.79 2.651 8.434 8.434 0 0 1-2.651 1.79 8.09 8.09 0 0 1-3.239.653zM1.667 10a8.09 8.09 0 0 1 .653-3.239A8.434 8.434 0 0 1 4.11 4.11 8.434 8.434 0 0 1 6.76 2.32 8.09 8.09 0 0 1 10 1.667c1.414 0 2.715.322 3.902.966a8.443 8.443 0 0 1 2.916 2.575V3.182h1.515v4.545h-4.545V6.212h1.875a6.86 6.86 0 0 0-2.396-2.197c-.991-.555-2.08-.833-3.267-.833-.947 0-1.834.18-2.661.54A6.93 6.93 0 0 0 5.18 5.18a6.93 6.93 0 0 0-1.458 2.159A6.596 6.596 0 0 0 3.182 10H1.667z" />
            <path d="M7.5 14.167V5.833L14.167 10z" />
        </g>
    </svg>
);

const IconSavedSearch = () => (
    <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <g id="Icon-/-Search-/-Saved" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Group-4" transform="translate(4, 2.0003)">
                <path
                    d="M1.90250075,5.76823481 C1.90250075,9.94148748 5.35565724,13.3245772 9.61534163,13.3245772 C10.0624365,13.3245772 10.5006463,13.2873073 10.9269107,13.2157657 L10.9265246,18.0535882 C10.9265246,18.8783295 9.92327514,19.3069392 9.30639309,18.745743 L5.46326229,15.2495554 L1.62013149,18.745743 C1.02452124,19.2875876 0.0687302027,18.9067119 0.0035217961,18.1374688 L0,18.0535882 L0,7.34876976 C0,6.23878902 0.837550474,5.32045941 1.92726628,5.16728823 C1.91059141,5.3660794 1.90250075,5.56623144 1.90250075,5.76823481 Z"
                    id="Combined-Shape"
                    fill="#000000"
                ></path>
                <g
                    id="Group"
                    transform="translate(10.8834, 7.286) rotate(-0.8) translate(-10.8834, -7.286)translate(3.8668, 0.0969)"
                >
                    <ellipse
                        id="Oval"
                        stroke="#000000"
                        strokeWidth="1.89528466"
                        cx="5.78463066"
                        cy="5.6672568"
                        rx="4.83698833"
                        ry="4.71961447"
                    ></ellipse>
                    <polygon
                        id="Path-3"
                        fill="#000000"
                        fillRule="nonzero"
                        points="9.31968273 7.97922862 10.2286497 8.86975211 13.1241951 11.706545 14.0331621 12.5970685 12.2152281 14.3781155 11.306261 13.487592 8.41071572 10.6507991 7.5017487 9.7602756"
                    ></polygon>
                </g>
            </g>
        </g>
    </svg>
);

const IconSearchMode = () => (
    <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <title>Icon / Method</title>
        <g id="Icon-/-Method" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g
                id="frame_inspect_FILL0_wght400_GRAD0_opsz24"
                transform="translate(3, 3)"
                fill="#000000"
                fillRule="nonzero"
            >
                <path
                    d="M8.25,10.5 C8.88333333,10.5 9.41666667,10.2833333 9.85,9.85 C10.2833333,9.41666667 10.5,8.88333333 10.5,8.25 C10.5,7.61666667 10.2833333,7.08333333 9.85,6.65 C9.41666667,6.21666667 8.88333333,6 8.25,6 C7.61666667,6 7.08333333,6.21666667 6.65,6.65 C6.21666667,7.08333333 6,7.61666667 6,8.25 C6,8.88333333 6.21666667,9.41666667 6.65,9.85 C7.08333333,10.2833333 7.61666667,10.5 8.25,10.5 Z M13.075,14.5 L10.45,11.875 C10.1166667,12.0916667 9.7625,12.25 9.3875,12.35 C9.0125,12.45 8.63333333,12.5 8.25,12.5 C7.06666667,12.5 6.0625,12.0875 5.2375,11.2625 C4.4125,10.4375 4,9.43333333 4,8.25 C4,7.06666667 4.4125,6.0625 5.2375,5.2375 C6.0625,4.4125 7.06666667,4 8.25,4 C9.43333333,4 10.4375,4.4125 11.2625,5.2375 C12.0875,6.0625 12.5,7.06666667 12.5,8.25 C12.5,8.63333333 12.4458333,9.0125 12.3375,9.3875 C12.2291667,9.7625 12.0666667,10.1166667 11.85,10.45 L14.5,13.1 L13.075,14.5 Z M2,18 C1.45,18 0.979166667,17.8041667 0.5875,17.4125 C0.195833333,17.0208333 0,16.55 0,16 L0,12 L2,12 L2,16 L6,16 L6,18 L2,18 Z M12,18 L12,16 L16,16 L16,12 L18,12 L18,16 C18,16.55 17.8041667,17.0208333 17.4125,17.4125 C17.0208333,17.8041667 16.55,18 16,18 L12,18 Z M0,6 L0,2 C0,1.45 0.195833333,0.979166667 0.5875,0.5875 C0.979166667,0.195833333 1.45,0 2,0 L6,0 L6,2 L2,2 L2,6 L0,6 Z M16,6 L16,2 L12,2 L12,0 L16,0 C16.55,0 17.0208333,0.195833333 17.4125,0.5875 C17.8041667,0.979166667 18,1.45 18,2 L18,6 L16,6 Z"
                    id="Shape"
                ></path>
            </g>
        </g>
    </svg>
);

const IconSearchScope = () => (
    <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <title>Icon / Scope</title>
        <g id="Icon-/-Scope" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g
                id="biotech_FILL0_wght400_GRAD0_opsz24"
                transform="translate(5, 2)"
                fill="#000000"
                fillRule="nonzero"
            >
                <path
                    d="M0,19 L0,17 L5,17 L5,15 C3.61666667,15 2.4375,14.5125 1.4625,13.5375 C0.4875,12.5625 0,11.3833333 0,10 C0,8.98333333 0.279166667,8.05833333 0.8375,7.225 C1.39583333,6.39166667 2.15,5.78333333 3.1,5.4 C3.23333333,4.83333333 3.52916667,4.375 3.9875,4.025 C4.44583333,3.675 4.96666667,3.5 5.55,3.5 L5,1.95 L5.95,1.6 L5.6,0.7 L7.5,0 L7.8,0.95 L8.75,0.6 L11.5,8.1 L10.55,8.45 L10.9,9.4 L9,10.1 L8.7,9.15 L7.75,9.5 L7.15,7.85 C6.9,8.08333333 6.6125,8.25833333 6.2875,8.375 C5.9625,8.49166667 5.63333333,8.53333333 5.3,8.5 C4.93333333,8.46666667 4.59166667,8.35416667 4.275,8.1625 C3.95833333,7.97083333 3.68333333,7.73333333 3.45,7.45 C3,7.71666667 2.64583333,8.075 2.3875,8.525 C2.12916667,8.975 2,9.46666667 2,10 C2,10.8333333 2.29166667,11.5416667 2.875,12.125 C3.45833333,12.7083333 4.16666667,13 5,13 L13,13 L13,15 L8,15 L8,17 L14,17 L14,19 L0,19 Z M8.65,7.55 L9.55,7.2 L7.85,2.5 L6.9,2.85 L8.65,7.55 Z M5.5,7 C5.78333333,7 6.02083333,6.90416667 6.2125,6.7125 C6.40416667,6.52083333 6.5,6.28333333 6.5,6 C6.5,5.71666667 6.40416667,5.47916667 6.2125,5.2875 C6.02083333,5.09583333 5.78333333,5 5.5,5 C5.21666667,5 4.97916667,5.09583333 4.7875,5.2875 C4.59583333,5.47916667 4.5,5.71666667 4.5,6 C4.5,6.28333333 4.59583333,6.52083333 4.7875,6.7125 C4.97916667,6.90416667 5.21666667,7 5.5,7 Z"
                    id="Shape"
                ></path>
            </g>
        </g>
    </svg>
);

const IconState = () => (
    <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <title>Icon / State</title>
        <g id="Icon-/-State" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g
                id="history_edu_FILL0_wght400_GRAD0_opsz24"
                transform="translate(2, 4)"
                fill="#000000"
                fillRule="nonzero"
            >
                <path
                    d="M6.5,16 C5.95,16 5.47916667,15.8041667 5.0875,15.4125 C4.69583333,15.0208333 4.5,14.55 4.5,14 L4.5,11 L7.5,11 L7.5,8.75 C6.91666667,8.71666667 6.3625,8.5875 5.8375,8.3625 C5.3125,8.1375 4.83333333,7.8 4.4,7.35 L4.4,6.25 L3.25,6.25 L0,3 C0.6,2.23333333 1.34166667,1.69166667 2.225,1.375 C3.10833333,1.05833333 4,0.9 4.9,0.9 C5.35,0.9 5.7875,0.933333333 6.2125,1 C6.6375,1.06666667 7.06666667,1.19166667 7.5,1.375 L7.5,0 L19.5,0 L19.5,13 C19.5,13.8333333 19.2083333,14.5416667 18.625,15.125 C18.0416667,15.7083333 17.3333333,16 16.5,16 L6.5,16 Z M9.5,11 L15.5,11 L15.5,13 C15.5,13.2833333 15.5958333,13.5208333 15.7875,13.7125 C15.9791667,13.9041667 16.2166667,14 16.5,14 C16.7833333,14 17.0208333,13.9041667 17.2125,13.7125 C17.4041667,13.5208333 17.5,13.2833333 17.5,13 L17.5,2 L9.5,2 L9.5,2.6 L15.5,8.6 L15.5,10 L14.1,10 L11.25,7.15 L11.05,7.35 C10.8166667,7.58333333 10.5708333,7.79166667 10.3125,7.975 C10.0541667,8.15833333 9.78333333,8.3 9.5,8.4 L9.5,11 Z M4.1,4.25 L6.4,4.25 L6.4,6.4 C6.6,6.53333333 6.80833333,6.625 7.025,6.675 C7.24166667,6.725 7.46666667,6.75 7.7,6.75 C8.08333333,6.75 8.42916667,6.69166667 8.7375,6.575 C9.04583333,6.45833333 9.35,6.25 9.65,5.95 L9.85,5.75 L8.45,4.35 C7.96666667,3.86666667 7.425,3.50416667 6.825,3.2625 C6.225,3.02083333 5.58333333,2.9 4.9,2.9 C4.56666667,2.9 4.25,2.925 3.95,2.975 C3.65,3.025 3.35,3.1 3.05,3.2 L4.1,4.25 Z M13.5,13 L6.5,13 L6.5,14 L13.65,14 C13.6,13.85 13.5625,13.6916667 13.5375,13.525 C13.5125,13.3583333 13.5,13.1833333 13.5,13 Z M6.5375,14 L6.5375,13 L6.5375,14 Z"
                    id="Shape"
                ></path>
            </g>
        </g>
    </svg>
);

const IconSubset = () => (
    <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <title>Icon / Subset</title>
        <g id="Icon-/-Subset" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <path
                d="M14.3422144,1.83201965 L17.6110684,2.06060018 L22.1267581,7.37933837 L21.7008258,13.4704553 C21.6440348,14.2826042 21.3218007,14.9491539 20.7341237,15.4701046 C20.5055339,15.6727396 20.2611432,15.8317513 20.0009515,15.9471397 L20,9.99078341 C20,9.46842868 19.7956386,8.96680267 19.4306109,8.5931595 L19.0196866,8.17294934 L20.5600127,8.28146184 L16.3848786,3.47851949 L16.2546866,5.34194934 L14.5549046,3.60237609 C14.2203938,3.25997013 13.7757075,3.0503344 13.3027978,3.00797591 L13.1242938,3 L11.8356866,3.00033073 C11.9583881,2.83216744 12.1017847,2.67535567 12.2658763,2.52989544 C12.8535534,2.00894483 13.5456661,1.77631956 14.3422144,1.83201965 Z"
                id="Combined-Shape"
                fill="#000000"
                fillRule="nonzero"
            ></path>
            <path
                d="M13.1242938,5 L18,9.99078341 L18,16.0967742 C18,16.9109063 17.7250471,17.5983103 17.1751412,18.1589862 C16.6545327,18.689791 16.0225216,18.9693332 15.2791079,18.9976128 C15.2820589,18.8538949 15.2777025,18.7094251 15.2675069,18.5636211 L14.8415745,12.4725042 C14.8051369,11.9514219 14.5662816,11.4652734 14.1760791,11.1180034 L14.042891,11 L16.5,11 L12,6.5 L11.999891,9.181 L8.96411036,6.47948938 C8.61364038,6.16758038 8.16648792,5.99028563 7.70189104,5.97463262 L7.82485876,5.84101382 C8.3747646,5.28033794 9.04896422,5 9.84745763,5 L13.1242938,5 Z"
                id="Combined-Shape"
                fill="#000000"
                fillRule="nonzero"
            ></path>
            <path
                d="M4.84745763,22 C4.04896422,22 3.3747646,21.7196621 2.82485876,21.1589862 C2.27495292,20.5983103 2,19.9109063 2,19.0967742 L2,10.9032258 C2,10.0890937 2.27495292,9.40168971 2.82485876,8.84101382 C3.3747646,8.28033794 4.04896422,8 4.84745763,8 L8.12429379,8 L13,12.9907834 L13,19.0967742 C13,19.9109063 12.7250471,20.5983103 12.1751412,21.1589862 C11.6252354,21.7196621 10.9510358,22 10.1525424,22 L4.84745763,22 Z M7,14 L11.5,14 L7,9.5 L7,14 Z"
                id="Shape"
                fill="#000000"
                fillRule="nonzero"
                transform="translate(7.5, 15) rotate(-4) translate(-7.5, -15)"
            ></path>
        </g>
    </svg>
);

const IconTimeTravel = () => (
    <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <title>Icon / Time Travel</title>
        <g id="Icon-/-Time-Travel" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g
                id="update_24dp_FILL0_wght400_GRAD0_opsz24"
                transform="translate(3, 3)"
                fill="#000000"
                fillRule="nonzero"
            >
                <path
                    d="M9,18 C7.75,18 6.57916667,17.7625 5.4875,17.2875 C4.39583333,16.8125 3.44583333,16.1708333 2.6375,15.3625 C1.82916667,14.5541667 1.1875,13.6041667 0.7125,12.5125 C0.2375,11.4208333 0,10.25 0,9 C0,7.75 0.2375,6.57916667 0.7125,5.4875 C1.1875,4.39583333 1.82916667,3.44583333 2.6375,2.6375 C3.44583333,1.82916667 4.39583333,1.1875 5.4875,0.7125 C6.57916667,0.2375 7.75,0 9,0 C10.3666667,0 11.6625,0.291666667 12.8875,0.875 C14.1125,1.45833333 15.15,2.28333333 16,3.35 L16,1 L18,1 L18,7 L12,7 L12,5 L14.75,5 C14.0666667,4.06666667 13.225,3.33333333 12.225,2.8 C11.225,2.26666667 10.15,2 9,2 C7.05,2 5.39583333,2.67916667 4.0375,4.0375 C2.67916667,5.39583333 2,7.05 2,9 C2,10.95 2.67916667,12.6041667 4.0375,13.9625 C5.39583333,15.3208333 7.05,16 9,16 C10.75,16 12.2791667,15.4333333 13.5875,14.3 C14.8958333,13.1666667 15.6666667,11.7333333 15.9,10 L17.95,10 C17.7,12.2833333 16.7208333,14.1875 15.0125,15.7125 C13.3041667,17.2375 11.3,18 9,18 Z M11.8,13.2 L8,9.4 L8,4 L10,4 L10,8.6 L13.2,11.8 L11.8,13.2 Z"
                    id="Shape"
                ></path>
            </g>
        </g>
    </svg>
);

const IconReturnKey = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
            fill="#000"
            fillRule="nonzero"
            d="m9 18-6-6 6-6 1.4 1.4L6.8 11H19V7h2v6H6.8l3.6 3.6z"
        />
    </svg>
);

const IconEscKey = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <g fill="#000" fillRule="nonzero">
            <path d="M2 16.333V7.667h5.685v1.558H3.877v1.822h3.12v1.558h-3.12v2.17h3.781v1.558zM11.629 16.5a5.54 5.54 0 0 1-1.641-.243c-.527-.163-.952-.415-1.276-.759l.918-1.571.068-.112.135.084c.018.065.042.132.074.201a.87.87 0 0 0 .223.258c.216.148.45.273.702.375.252.102.513.158.783.167.37.01.666-.05.891-.18.225-.13.338-.362.338-.696a.977.977 0 0 0-.101-.431c-.068-.14-.205-.292-.412-.46-.207-.166-.527-.352-.959-.556-.576-.287-1.033-.56-1.37-.82-.338-.26-.581-.545-.73-.856-.148-.31-.223-.684-.223-1.12 0-.426.124-.811.372-1.154a2.608 2.608 0 0 1 1.006-.821 3.16 3.16 0 0 1 1.39-.306c.577 0 1.083.093 1.52.278a3.48 3.48 0 0 1 1.195.863l-1.148 1.28-.08.097-.122-.112a1.655 1.655 0 0 0-.04-.215c-.019-.07-.077-.16-.176-.271a1.093 1.093 0 0 0-.46-.258 2.289 2.289 0 0 0-.567-.062c-.306 0-.553.062-.743.187-.189.126-.283.272-.283.439 0 .139.031.264.094.375.063.112.203.239.42.383.215.144.553.336 1.012.577.585.297 1.044.58 1.377.849.333.269.57.563.71.883.139.32.209.702.209 1.147 0 .436-.108.849-.324 1.239-.217.389-.554.707-1.013.952-.46.246-1.05.369-1.77.369zM19.137 16.5a3.197 3.197 0 0 1-1.695-.473c-.517-.315-.93-.802-1.235-1.46-.306-.659-.46-1.498-.46-2.518 0-.853.106-1.57.318-2.15.211-.58.49-1.045.837-1.397a3.207 3.207 0 0 1 1.134-.766c.41-.157.817-.236 1.223-.236 1.314 0 2.228.561 2.741 1.683l-1.053.974-.095.083-.094-.11a.94.94 0 0 0-.027-.224 1 1 0 0 0-.149-.292 1.294 1.294 0 0 0-.554-.41c-.198-.07-.4-.104-.607-.104-.261 0-.53.104-.804.313-.274.208-.504.524-.689.946-.184.422-.276.962-.276 1.62 0 .946.146 1.667.438 2.163.293.496.673.744 1.142.744.324 0 .59-.058.796-.173.207-.116.41-.35.608-.703l1.296 1.016c-.342.565-.742.952-1.201 1.161-.46.209-.99.313-1.594.313z" />
        </g>
    </svg>
);

const IconDownArrow = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
            fill="#000"
            fillRule="nonzero"
            d="M13 4v12.175l5.6-5.6L20 12l-8 8-8-8 1.4-1.425 5.6 5.6V4z"
        />
    </svg>
);

const IconUpArrow = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
            fill="#000"
            fillRule="nonzero"
            d="M11 20V7.825l-5.6 5.6L4 12l8-8 8 8-1.4 1.425-5.6-5.6V20z"
        />
    </svg>
);

const IconExpandLeft = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
            fill="#000"
            fillRule="nonzero"
            d="m7.848 12 6.452 6.5 1.852-1.866-4.6-4.634 4.6-4.634L14.3 5.5z"
        />
    </svg>
);

const IconAbove = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
            fill="#000"
            fillRule="nonzero"
            d="m4 10 1.425 1.425L9 7.825V19h12v-2H11V7.825l3.6 3.6 1.425-1.4L10 4z"
        />
    </svg>
);

const IconHelp = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M11.95 18c.35 0 .646-.12.888-.363.241-.241.362-.537.362-.887s-.12-.646-.362-.887a1.207 1.207 0 0 0-.888-.363c-.35 0-.646.12-.887.363a1.207 1.207 0 0 0-.363.887c0 .35.12.646.363.887.241.242.537.363.887.363zm-.9-3.85h1.85c0-.55.063-.983.188-1.3.125-.317.479-.75 1.062-1.3a7.495 7.495 0 0 0 1.025-1.238c.25-.391.375-.862.375-1.412 0-.933-.342-1.65-1.025-2.15-.683-.5-1.492-.75-2.425-.75-.95 0-1.72.25-2.313.75-.591.5-1.004 1.1-1.237 1.8l1.65.65c.083-.3.27-.625.563-.975.291-.35.737-.525 1.337-.525.533 0 .933.146 1.2.437.267.292.4.613.4.963 0 .333-.1.646-.3.938-.2.291-.45.562-.75.812-.733.65-1.183 1.142-1.35 1.475-.167.333-.25.942-.25 1.825zM12 22a9.738 9.738 0 0 1-3.9-.788 10.099 10.099 0 0 1-3.175-2.137c-.9-.9-1.612-1.958-2.137-3.175A9.738 9.738 0 0 1 2 12c0-1.383.263-2.683.788-3.9a10.099 10.099 0 0 1 2.137-3.175c.9-.9 1.958-1.612 3.175-2.137A9.738 9.738 0 0 1 12 2c1.383 0 2.683.263 3.9.788a10.099 10.099 0 0 1 3.175 2.137c.9.9 1.613 1.958 2.137 3.175A9.738 9.738 0 0 1 22 12a9.738 9.738 0 0 1-.788 3.9 10.099 10.099 0 0 1-2.137 3.175c-.9.9-1.958 1.613-3.175 2.137A9.738 9.738 0 0 1 12 22zm0-2c2.233 0 4.125-.775 5.675-2.325C19.225 16.125 20 14.233 20 12c0-2.233-.775-4.125-2.325-5.675C16.125 4.775 14.233 4 12 4c-2.233 0-4.125.775-5.675 2.325C4.775 7.875 4 9.767 4 12c0 2.233.775 4.125 2.325 5.675C7.875 19.225 9.767 20 12 20z"
            fill="#000"
            fillRule="nonzero"
        />
    </svg>
);

const IconSearch = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
            d="m19.1 20.5-5.3-5.3a6.095 6.095 0 0 1-3.8 1.3c-1.817 0-3.354-.63-4.612-1.887C4.129 13.354 3.5 11.817 3.5 10c0-1.817.63-3.354 1.888-4.612C6.646 4.129 8.183 3.5 10 3.5c1.817 0 3.354.63 4.613 1.888C15.87 6.646 16.5 8.183 16.5 10a6.095 6.095 0 0 1-1.3 3.8l5.3 5.3-1.4 1.4zm-9.1-6c1.25 0 2.313-.438 3.188-1.313.874-.874 1.312-1.937 1.312-3.187 0-1.25-.438-2.313-1.313-3.188C12.313 5.938 11.25 5.5 10 5.5c-1.25 0-2.313.438-3.188 1.313S5.5 8.75 5.5 10c0 1.25.438 2.313 1.313 3.188C7.688 14.062 8.75 14.5 10 14.5z"
            fill="#000"
            fillRule="nonzero"
        />
    </svg>
);

const IconMethod = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M11.25 13.5c.633 0 1.167-.217 1.6-.65.433-.433.65-.967.65-1.6 0-.633-.217-1.167-.65-1.6-.433-.433-.967-.65-1.6-.65-.633 0-1.167.217-1.6.65-.433.433-.65.967-.65 1.6 0 .633.217 1.167.65 1.6.433.433.967.65 1.6.65zm4.825 4-2.625-2.625a3.679 3.679 0 0 1-1.063.475c-.375.1-.754.15-1.137.15-1.183 0-2.188-.412-3.012-1.238C7.413 13.438 7 12.433 7 11.25s.412-2.188 1.238-3.012C9.063 7.413 10.067 7 11.25 7s2.188.412 3.012 1.238c.825.825 1.238 1.829 1.238 3.012 0 .383-.054.762-.162 1.137-.109.375-.271.73-.488 1.063l2.65 2.65-1.425 1.4zM5 21c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 3 19v-4h2v4h4v2H5zm10 0v-2h4v-4h2v4c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 19 21h-4zM3 9V5c0-.55.196-1.02.587-1.413A1.926 1.926 0 0 1 5 3h4v2H5v4H3zm16 0V5h-4V3h4c.55 0 1.02.196 1.413.587C20.803 3.98 21 4.45 21 5v4h-2z"
            fill="#000"
            fillRule="nonzero"
        />
    </svg>
);

const IconAdditionalSearchOptions = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <g fill="#000" fillRule="nonzero">
            <path d="M11 18c1.933 0 3.583-.68 4.95-2.037C17.317 14.604 18 12.95 18 11c0-1.933-.683-3.583-2.05-4.95C14.583 4.683 12.933 4 11 4c-1.95 0-3.604.683-4.963 2.05C4.68 7.417 4 9.067 4 11c0 1.95.68 3.604 2.037 4.963C7.396 17.32 9.05 18 11 18zm9.575 4L16.6 18.05a9.217 9.217 0 0 1-2.6 1.438c-.95.341-1.95.512-3 .512-1.25 0-2.42-.238-3.513-.712a9.148 9.148 0 0 1-2.85-1.925 9.148 9.148 0 0 1-1.924-2.85A8.707 8.707 0 0 1 2 11c0-1.233.237-2.396.712-3.487A9.303 9.303 0 0 1 4.638 4.65a9.042 9.042 0 0 1 2.85-1.938A8.707 8.707 0 0 1 11 2c1.233 0 2.396.237 3.488.712A9.193 9.193 0 0 1 17.35 4.65a9.193 9.193 0 0 1 1.938 2.862A8.646 8.646 0 0 1 20 11a8.68 8.68 0 0 1-.525 3.025 9.465 9.465 0 0 1-1.45 2.6L22 20.6 20.575 22z" />
            <path d="m9.97 16-.31-1.5c-.206-.083-.4-.17-.58-.262a4.51 4.51 0 0 1-.554-.338l-1.495.45L6 12.65l1.186-1a4.48 4.48 0 0 1-.052-.65c0-.2.017-.417.052-.65L6 9.35l1.03-1.7 1.496.45a4.51 4.51 0 0 1 .554-.337c.18-.092.374-.18.58-.263L9.97 6h2.06l.31 1.5c.206.083.4.175.58.275.18.1.365.225.554.375l1.495-.5L16 9.4l-1.186 1c.035.2.052.408.052.625 0 .217-.017.425-.052.625l1.186 1-1.03 1.7-1.496-.45a4.51 4.51 0 0 1-.554.338c-.18.091-.374.179-.58.262l-.31 1.5H9.97zM11 13c.55 0 1.02-.196 1.412-.588.392-.391.588-.862.588-1.412 0-.55-.196-1.02-.588-1.412A1.926 1.926 0 0 0 11 9c-.55 0-1.02.196-1.412.588A1.926 1.926 0 0 0 9 11c0 .55.196 1.02.588 1.412.391.392.862.588 1.412.588z" />
        </g>
    </svg>
);

const IconCustomOptions = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <g fill="#000" fillRule="nonzero">
            <path d="m6.97 13-.31-1.5c-.206-.083-.4-.17-.58-.262a4.51 4.51 0 0 1-.554-.338l-1.495.45L3 9.65l1.186-1A4.48 4.48 0 0 1 4.134 8c0-.2.017-.417.052-.65L3 6.35l1.03-1.7 1.496.45a4.51 4.51 0 0 1 .554-.337c.18-.092.374-.18.58-.263L6.97 3h2.06l.31 1.5c.206.083.4.175.58.275.18.1.365.225.554.375l1.495-.5L13 6.4l-1.186 1c.035.2.052.408.052.625 0 .217-.017.425-.052.625l1.186 1-1.03 1.7-1.496-.45a4.51 4.51 0 0 1-.554.338c-.18.091-.374.179-.58.262L9.03 13H6.97zM8 10c.55 0 1.02-.196 1.412-.588C9.804 9.021 10 8.55 10 8c0-.55-.196-1.02-.588-1.412A1.926 1.926 0 0 0 8 6c-.55 0-1.02.196-1.412.588A1.926 1.926 0 0 0 6 8c0 .55.196 1.02.588 1.412C6.979 9.804 7.45 10 8 10zM8.556 19.444h1.108l7.603-7.602-1.109-1.109-7.602 7.603v1.108zM7 21v-3.306L17.267 7.447c.155-.142.327-.253.515-.33.188-.078.386-.117.593-.117.207 0 .408.039.603.117.194.077.363.194.505.35l1.07 1.089c.155.142.269.31.34.505a1.685 1.685 0 0 1 0 1.177c-.071.187-.185.36-.34.515L10.306 21H7zM19.444 9.644l-1.088-1.088 1.088 1.088zm-2.741 1.653-.545-.564 1.109 1.109-.564-.545z" />
        </g>
    </svg>
);

const IconEdit = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
            <rect
                stroke="#30588C"
                strokeWidth="2"
                x="4.333"
                y="4.333"
                width="11.333"
                height="11.333"
                rx="3"
            />
            <path
                d="M7.963 12.037h.924l6.335-6.336-.923-.923-6.336 6.335v.924zm-1.296 1.296V10.58l8.555-8.54c.13-.118.273-.21.43-.275a1.34 1.34 0 0 1 .997 0c.161.065.302.162.42.292l.892.907c.13.119.224.26.283.421a1.404 1.404 0 0 1 0 .98c-.06.157-.154.3-.283.43l-8.54 8.54H6.667zm10.37-9.463-.907-.907.907.907zm-2.285 1.378-.453-.47.923.923-.47-.453z"
                fill="#30588C"
                fillRule="nonzero"
            />
        </g>
    </svg>
);

const IconDelete = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M5.833 17.5c-.458 0-.85-.163-1.177-.49a1.605 1.605 0 0 1-.49-1.177V5h-.833V3.333H7.5V2.5h5v.833h4.167V5h-.834v10.833c0 .459-.163.851-.49 1.177-.326.327-.718.49-1.176.49H5.833zM14.167 5H5.833v10.833h8.334V5zM7.5 14.167h1.667v-7.5H7.5v7.5zm3.333 0H12.5v-7.5h-1.667v7.5zM5.873 5v10.833V5z"
            fill="#30588C"
            fillRule="nonzero"
        />
    </svg>
);

const IconTod = () => (
    <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
            <path d="M0-.003h12v12H0z" />
            <path opacity=".87" d="M0-.003h12v12H0z" />
            <path
                d="M1.5 3.122h1v-1h-1v1zm2-1v1h7v-1h-7zm-2 1h1v-1h-1v1zm2-1v1h7v-1h-7zM1.5 5.372h1v-1h-1v1zm2-1v1h7v-1h-7zm-2 1h1v-1h-1v1zm2-1v1h7v-1h-7zM1.5 7.622h1v-1h-1v1zm2-1v1h7v-1h-7zm-2 1h1v-1h-1v1zm2-1v1h7v-1h-7zM1.5 9.872h1v-1h-1v1zm2-1v1h7v-1h-7zm-2 1h1v-1h-1v1zm2-1v1h7v-1h-7z"
                fill="#2F2F2F"
                fillRule="nonzero"
            />
        </g>
    </svg>
);

const IconCurrentDoc = () => (
    <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
        <path
            d="m4.703 6.742.552.552.994-.994v.752l.773.002-.001-2.078-2.078-.002.001.774h.753l-.994.994zm-1.178 1.73c-.343-.344-.6-.73-.771-1.161a3.533 3.533 0 0 1-.257-1.314c0-.445.086-.883.257-1.314.17-.43.428-.818.771-1.161.343-.343.73-.6 1.161-.772.43-.17.869-.256 1.314-.256.445 0 .883.085 1.314.256.43.171.818.429 1.16.772.344.343.601.73.772 1.16.171.432.257.87.257 1.315 0 .445-.086.883-.257 1.314-.17.43-.428.817-.771 1.16-.343.344-.73.601-1.161.772-.43.171-.869.257-1.314.257-.445 0-.883-.086-1.314-.257a3.411 3.411 0 0 1-1.16-.771zm.552-.552c.538.538 1.179.807 1.923.807s1.385-.27 1.923-.807c.538-.538.807-1.18.807-1.923 0-.745-.27-1.386-.807-1.923-.538-.538-1.179-.807-1.923-.807s-1.385.269-1.923.807c-.538.537-.807 1.178-.807 1.923 0 .744.27 1.385.807 1.923z"
            fill="#2F396B"
            fillRule="nonzero"
        />
    </svg>
);

const IconTick = () => (
    <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
        <path
            d="m5.518 7.627 2.425-2.425-.594-.6-1.83 1.83-.896-.894-.595.6 1.49 1.49zM6 9.497c-.487 0-.943-.092-1.368-.275a3.528 3.528 0 0 1-1.11-.747 3.528 3.528 0 0 1-.747-1.11A3.417 3.417 0 0 1 2.5 5.997c0-.487.092-.944.275-1.369.184-.425.433-.795.747-1.11a3.528 3.528 0 0 1 1.11-.746A3.417 3.417 0 0 1 6 2.497c.487 0 .943.091 1.368.275.426.183.795.432 1.11.747.314.314.563.684.747 1.11.183.424.275.88.275 1.368 0 .487-.092.943-.275 1.368a3.528 3.528 0 0 1-.747 1.11 3.528 3.528 0 0 1-1.11.747A3.417 3.417 0 0 1 6 9.497z"
            fill="#2F396B"
            fillRule="nonzero"
            opacity=".6"
        />
    </svg>
);

const icons = {
    above: IconAbove,
    acrossArrow: IconAcrossArrow,
    addAnnotation: IconAddAnnotation,
    addFavourite: IconAddFavourite,
    additionalSearchOptions: IconAdditionalSearchOptions,
    ai: IconAI,
    annotation: IconAnnotation,
    annotationHover: IconAnnotationHover,
    browse: IconBrowse,
    collection: IconCollection,
    currentDoc: IconCurrentDoc,
    customOptions: IconCustomOptions,
    date: IconDate,
    dateSelect: IconDateSelect,
    default: IconDefault,
    delete: IconDelete,
    document: IconDocument,
    documentSearch: IconDocumentSearch,
    DownArrow: IconDownArrow,
    dropdown: IconDropdownChevron,
    edit: IconEdit,
    EscKey: IconEscKey,
    expandLeft: IconExpandLeft,
    favourite: IconFavourite,
    filter: IconFilter,
    filterDocument: IconFilterDocument,
    grip: IconGrip,
    group: IconGroup,
    help: IconHelp,
    method: IconMethod,
    newSearch: IconNewSearch,
    openInNew: IconOpenInNew,
    oswaldLeft: IconOswaldPointLeft,
    private: IconPrivate,
    project: IconProject,
    refine: IconRefine,
    rerun: IconRerun,
    returnKey: IconReturnKey,
    savedSearch: IconSavedSearch,
    search: IconSearch,
    searchMode: IconSearchMode,
    searchScope: IconSearchScope,
    state: IconState,
    subset: IconSubset,
    tick: IconTick,
    timeTravel: IconTimeTravel,
    tod: IconTod,
    UpArrow: IconUpArrow,
};

export default icons;
